import axios, {AxiosResponse} from 'axios'
import {corporateApi} from '../../../../setup/axios/CorporateApi'
import {ApiResponse, PageResponse} from '../../../../shared/models/ApiModels'
import {filterParams} from '../application/Api'
import {IListFilters} from '../shared/SearchFilterBar'
import {IAssignRequest, ICallJobOption, ICallPoolEntryModel, ICorporateUserOption} from './CallPoolModel'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')
const CALL_POOL_URL = `${API_URL}api/v1/call-pool/`

/** Oturumdaki firmanın aktif kullanıcıları (gateway) */
export function loadCorporateUsers(): Promise<AxiosResponse<ApiResponse<ICorporateUserOption[]>>> {
  return axios.get(`${API_URL}api/v1/corporate/profile/users`)
}

export function assignToCallPool(
  request: IAssignRequest
): Promise<AxiosResponse<ApiResponse<{assigned: number; skipped: number}>>> {
  return corporateApi.post(`${CALL_POOL_URL}assign`, request)
}

/** Oturumdaki kullanıcıya atanmış, aranmayı bekleyen adaylar; en eski atama üstte */
export function searchCallPool(
  filters: Partial<IListFilters>,
  page = 0,
  size = 10
): Promise<AxiosResponse<ApiResponse<PageResponse<ICallPoolEntryModel>>>> {
  return corporateApi.get(`${CALL_POOL_URL}search`, {
    params: {
      ...filterParams({q: filters.q, jobId: filters.jobId, tagId: filters.tagId}),
      page,
      size,
      sort: 'createdDate,asc',
    },
  })
}

export function getCallPoolEntry(id: string): Promise<AxiosResponse<ApiResponse<ICallPoolEntryModel>>> {
  return corporateApi.get(`${CALL_POOL_URL}getById/${id}`)
}

export function loadCallJobOptions(id: string): Promise<AxiosResponse<ApiResponse<ICallJobOption[]>>> {
  return corporateApi.get(`${CALL_POOL_URL}${id}/job-options`)
}

export function markCallPositive(id: string, jobIds: string[], salaryExpectation: string, note: string) {
  return corporateApi.post(`${CALL_POOL_URL}${id}/positive`, {jobIds, salaryExpectation, note})
}

export function markCallNegative(id: string, reason: string, note: string) {
  return corporateApi.post(`${CALL_POOL_URL}${id}/negative`, {reason, note})
}

export function removeFromCallPool(id: string) {
  return corporateApi.delete(`${CALL_POOL_URL}delete/${id}`)
}
